import React from 'react';
import { Login as LoginComponent } from '~/components/Auth/Login';
import { HipaaComponent as Hipaa } from '~/components/Auth/Hipaa';
import { AuthContext } from '~/services';

export function Login() {
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-6">
                    <AuthContext.Consumer>
                        {(auth) => <LoginComponent auth={auth} />}
                    </AuthContext.Consumer>
                    <Hipaa />
                </div>
            </div>
        </div>
    );
}
